import L from 'leaflet';
import 'leaflet-draw';
import { isEmpty } from 'lodash';
import {
  waypointListOptions,
  waypointListOptionsNoClick,
  rpaPathStyle
} from '../client/waypoint-style-chooser';
import { pointsCollectionFeatureToLineString } from '../geojson-utilities';
import editWaypoints from './editWaypoints';

import { getWaypointList } from '../../api/Missions/mission-operations';

/**
 * Draws the mission waypoint list and the rpa path.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {object} arg.mission - The mission object.
 * @param {?object} arg.geoJSONWaypointListLayer - The geoJSON layer where the take off point will be painted.
 * @param {?object} arg.geoJSONRpaPathLayer - The geoJSON layer where the take off point will be painted.
 * @param {Function} arg.getCurrentMapState - A function that gets the current variables needed from the map component.
 * @param {boolean} [arg.isFlight=false] - This boolean means we are working on the flight map.
 * @param {boolean} [arg.isMissionPlan=false] - This boolean means we are working on the mission plan map.
 * @param {boolean} [arg.isUpdate=false] - Flag to determine if we are doing an update.
 * @param {Function} [arg.waypointOnClick] - A function to call when a waypoint is clicked.
 * @returns {object} The leaflet layers where the waypoint list and the rpa path are painted.
 */
const drawWaypointListAndRPAPath = ({
  leafletMap,
  mission,
  geoJSONWaypointListLayer,
  geoJSONRpaPathLayer,
  getCurrentMapState,
  isUpdate = false,
  isFlight = false,
  isMissionPlan = false,
  waypointOnClick = () => console.error('No waypoint click action')
}) => {
  let newGeoJSONWaypointListLayer = '';
  let newGeoJSONRpaPathLayer = '';
  if (!isUpdate) {
    let waypointsStyle = {};
    if (isFlight) {
      waypointsStyle = waypointListOptions(waypointOnClick);
    } else {
      waypointsStyle = waypointListOptionsNoClick();
    }
    newGeoJSONWaypointListLayer = L.geoJSON(null, waypointsStyle).addTo(leafletMap);
    newGeoJSONRpaPathLayer = L.geoJSON(null, rpaPathStyle).addTo(leafletMap);

    if (isMissionPlan) {
      leafletMap.on(L.Draw.Event.EDITVERTEX, event =>
        editWaypoints({
          event,
          getCurrentMapState
        })
      );
    }
  } else {
    newGeoJSONWaypointListLayer = geoJSONWaypointListLayer;
    newGeoJSONRpaPathLayer = geoJSONRpaPathLayer;
    newGeoJSONWaypointListLayer.clearLayers();
    newGeoJSONRpaPathLayer.clearLayers();
  }

  const waypointList = getWaypointList(mission);

  if (!isEmpty(waypointList)) {
    const rpaPath = pointsCollectionFeatureToLineString(waypointList);
    newGeoJSONRpaPathLayer.addData(rpaPath);
    newGeoJSONWaypointListLayer.addData(waypointList);
  }
  return { newGeoJSONRpaPathLayer, newGeoJSONWaypointListLayer };
};

export default drawWaypointListAndRPAPath;
